module.exports = __webpack_public_path__ + "static/media/banner.4d319424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/quotation-request/banner.jpg
// module id = 562
// module chunks = 0